import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, makeStyles, ButtonBase } from '@material-ui/core';
import _ from 'lodash';
import htmlToDraft from 'html-to-draftjs';
import { ContentState, EditorState } from 'draft-js';
import Dialog from '../../../../../../components/Dialog';
import Text from '../../../../../../components/Text';
import { Checkbox } from '../../../../../DutyAssign/components/Attendance/Setting';
import TitleBox from '../../../../../Admission/components/TitleBox.js/index.js';
import { AutoCompleteSelect } from '../../../../../../components';
import RichText from '../../../../../Admission/components/RichText';
import { AddIcon, DeleteIcon, Reset2 } from '../../../../../../components/Icon';
import StyleInput from '../../../../../../components/StyleInput';
import { eadmissionAPI, systemAPI } from '../../../../../../apis';
import { AddWardPop } from '../../../Pops';
import { wardAssignByMapping } from '../../constant';
import { initValue } from '../../../../../../utils';
import AutoCompleteInput from '../../../../../../components/AutoCompleteInput';

const useStyles = makeStyles((theme) => ({
  border: {
    minHeight: '1px',
    maxHeight: '1px',
    backgroundColor: '#E4E7EB',
    flex: '1',
  },
  star: {
    color: '#FF0300',
    fontSize: '0.875rem',
  },
  btn: {
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
  addIcon: {
    fontSize: '1rem',
    marginRight: '0.38rem',
  },
  deleteBtn: {
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '7px',
    backgroundColor: '#538FFF',
  },
  deleteIcon: {
    fontSize: '1.5rem',
    color: '#FFF',
  },
  checkbox: {
    '&.Mui-disabled': {
      '& .MuiIconButton-label': {
        backgroundColor: '#f5f5f5',
      },
    },
  },
  checkBoxContainer: {
    marginLeft: '0rem',
    '& .MuiButtonBase-root': {
      padding: '0',
      paddingRight: '0.938rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

const initSpecialtyWardlocObj = {
  gender: '',
  ipasHospCode: '',
  ipasWardLocation: '',
  occThreshold: '',
  unitId: '',
  age: '',
  range: '',
  id: 1,
};

const SpecialtiesPopup = ({ handleClose, handleConfirm, type = 'Add', specialtyId }) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    additionalRemark: '',
    isActive: 1,
    redirOptAtWardAck: ['NEXT'],
    specialtyCode: '',
    specialtyWardId: '',
    specialtyWardloc: [initSpecialtyWardlocObj],
    subSpecialtyCode: '',
    wardAssignBy: '',
    isoRoom: '',
    isMatchedAge: false,
  });
  const [optionList, setOptionList] = useState({
    hospWardList: [],
    specialtyWardloc: [],
    specialtyCode: [],
    subSpecialtyCode: [],
    wardItemList: [],
    isoList: [],
  });
  const [addUnit, setAddUnit] = useState(false);
  const [defaultValue, setDefaultValue] = useState();

  const getSpecialtyDefaultList = async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialtyDefaultList();
      let additionalRemark = '';
      if (result.specialtyDefault.additionalRemark) {
        const blocksFromHtml = htmlToDraft(result.specialtyDefault.additionalRemark);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        additionalRemark = EditorState.createWithContent(contentState);
      }
      setDefaultValue({ ...result.specialtyDefault, additionalRemark });
    } catch (error) {
      console.log(error);
    }
  };

  const getRangeVal = (wardItem) => {
    if (wardItem?.ageBelow) {
      return 'ageBelow';
    } else if (wardItem?.ageOnAbove) {
      return 'ageOnAbove';
    } else {
      return '';
    }
  };

  const handleRevampWardLoc = (wardLocs) => {
    if (_.isArray(wardLocs) && wardLocs.length > 0) {
      return _.map(wardLocs, (item, index) => {
        let nenwWardLoc = {
          ...item,
          occThreshold: item?.occThreshold?.replace(/%/g, '') ?? '',
          id: index + 1,
          range: getRangeVal(item),
          age: (item?.ageBelow || item?.ageOnAbove) ?? '',
        };
        return nenwWardLoc;
      });
    }
    return [];
  };

  const getSpecialtyDetail = async () => {
    try {
      if (specialtyId) {
        const {
          result: { data },
        } = await eadmissionAPI.getSpecialtyDetail({ specialtyId });
        let additionalRemark = '';
        if (data[0].additionalRemark) {
          const blocksFromHtml = htmlToDraft(data[0].additionalRemark);
          const { contentBlocks, entityMap } = blocksFromHtml;
          const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
          additionalRemark = EditorState.createWithContent(contentState);
        }
        setForm({
          ...data[0],
          specialtyWardloc: handleRevampWardLoc(data[0].specialtyWardloc),
          additionalRemark,
          redirOptAtWardAck: initValue(data?.[0]?.redirOptAtWardAck, ['NEXT']),
          specialtyCode: data[0]?.specialtyCode ?? '',
          subSpecialtyCode: data[0]?.subSpecialtyCode ?? '',
          isoRoom: data[0]?.codeValue ?? '',
          isMatchedAge: data[0]?.isMatchedAge === 1,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateFormValue = (key, value) => {
    setForm((preData) => ({
      ...preData,
      [key]: value,
    }));
  };

  const updateForm = ({ key, id, keyword }) => {
    switch (key) {
      case 'additionalRemark':
      case 'specialtyCode':
      case 'subSpecialtyCode':
      case 'wardAssignBy':
      case 'specialtyWardId':
      case 'isoRoom':
        return (value) => updateFormValue(key, value);
      case 'isMatchedAge':
        return () =>
          setForm((preData) => ({
            ...preData,
            isMatchedAge: !preData.isMatchedAge,
          }));
      case 'isActive':
        return () =>
          setForm((preData) => ({
            ...preData,
            isActive: preData.isActive === 0 ? 1 : 0,
          }));
      case 'redirOptAtWardAck':
        return () =>
          setForm((preData) => ({
            ...preData,
            redirOptAtWardAck: _.some(preData.redirOptAtWardAck, (item) => item === keyword)
              ? _.filter(preData.redirOptAtWardAck, (item) => item !== keyword)
              : [...preData.redirOptAtWardAck, keyword],
          }));
      case 'specialtyWardloc':
        return (value) =>
          setForm((preData) => ({
            ...preData,
            specialtyWardloc: _.map(preData.specialtyWardloc, (item) => {
              if (item.id === id) {
                let temp = {
                  ...item,
                  [keyword]: value,
                };

                if (keyword === 'ipasHospCode') {
                  temp.ipasWardLocation = '';
                  temp.unitId = '';
                } else if (keyword === 'ipasWardLocation') {
                  temp.unitId = '';
                }

                return temp;
              } else {
                return item;
              }
            }),
          }));
      default:
        break;
    }
  };

  const getSysHospitalWardList = async () => {
    try {
      const { result } = await systemAPI.getSysHospitalWardList();
      setOptionList((preData) => ({
        ...preData,
        hospWardList: result[0].wards,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getSpecialtyWardloc = async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialtyWardloc();
      setOptionList((preData) => ({
        ...preData,
        specialtyWardloc: result.code,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getSpecialtyCode = async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialtyCode();
      setOptionList((preData) => ({
        ...preData,
        specialtyCode: result.specialtyCode,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getSubSpecialtyCode = async () => {
    try {
      const { result } = await eadmissionAPI.getSubSpecialtyCode();
      setOptionList((preData) => ({
        ...preData,
        subSpecialtyCode: result.subSpecialty,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getIsoRoomList = async () => {
    try {
      const { result } = await eadmissionAPI.getIsolationRoomList();
      setOptionList((preData) => ({
        ...preData,
        isoList: result,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getSysWardItemList = async () => {
    try {
      const { result } = await systemAPI.getSysWardItemList();
      setOptionList((preData) => ({
        ...preData,
        wardItemList: result?.[0]?.wards,
      }));
    } catch (error) {}
  };

  useEffect(() => {
    getSysHospitalWardList();
    getSpecialtyWardloc();
    getSpecialtyCode();
    getSubSpecialtyCode();
    getSpecialtyDefaultList();
    getSysWardItemList();
    getIsoRoomList();
  }, []);

  useEffect(() => {
    getSpecialtyDetail();
  }, [specialtyId]);

  const options = useMemo(() => {
    const specialOptions = _.map(optionList.specialtyCode, (item) => ({
      text: item,
      value: item,
    }));

    const subSpecialOptions = _.map(optionList.subSpecialtyCode, (item) => ({
      text: item,
      value: item,
    }));

    const hospCodeOptions = _.map(optionList.specialtyWardloc, (item) => ({
      text: item.hospCode,
      value: item.hospCode,
    }));

    const genderOptions = [
      {
        text: 'M',
        value: 'M',
      },
      {
        text: 'F',
        value: 'F',
      },
      {
        text: 'X',
        value: 'X',
      },
    ];

    const wardAssignmentList = _.map(wardAssignByMapping, (value, key) => ({ value: key, text: value }));

    const wardItemOptions = _.map(optionList.wardItemList, (item) => ({
      text: item.wardName,
      value: item.wardId,
    }));

    const isoRoomOptions = [
      { text: '', value: '' },
      ..._.map(optionList.isoList, (item) => ({
        text: item.codeDesc,
        value: item.codeValue,
      })),
    ].filter((item) => item.value !== 'Undefined');

    return {
      specialOptions,
      subSpecialOptions,
      hospCodeOptions,
      genderOptions,
      wardAssignmentList,
      wardItemOptions,
      isoRoomOptions,
    };
  }, [optionList]);

  const ageRangeOptions = [
    {
      text: '',
      value: '',
    },
    {
      text: '<',
      value: 'ageBelow',
    },
    {
      text: '>=',
      value: 'ageOnAbove',
    },
  ];

  const wardLocationGetter = useCallback(
    (hospCode) => {
      if (!hospCode) {
        return [];
      }
      const currentHosp = _.find(optionList.specialtyWardloc, (item) => item.hospCode === hospCode);
      const wardLocations = _.map(currentHosp?.wardLocation, (item) => ({
        text: item.location,
        value: item.location,
      }));

      return wardLocations;
    },
    [optionList.specialtyWardloc]
  );

  const wardGetter = useCallback(
    (hospCode, location) => {
      if (!hospCode) {
        return [];
      }
      if (!location) {
        return [];
      }
      const currentHosp = _.find(optionList.specialtyWardloc, (item) => item.hospCode === hospCode);
      const currentLocation = _.find(currentHosp?.wardLocation, (item) => item.location === location);
      const wards = _.map(currentLocation?.ward, (item) => ({
        text: item.wardName,
        value: item.wardId,
      }));

      return wards;
    },
    [optionList.specialtyWardloc]
  );

  const addPopConfirmClick = async (data) => {
    try {
      await systemAPI.createSysWard(data);
      await getSysHospitalWardList();
      setAddUnit(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddWardLocation = () => {
    setForm((preData) => ({
      ...preData,
      specialtyWardloc: [
        ...preData.specialtyWardloc,
        {
          ...initSpecialtyWardlocObj,
          id:
            preData.specialtyWardloc.length > 0
              ? preData.specialtyWardloc[preData.specialtyWardloc.length - 1].id + 1
              : 1,
        },
      ],
    }));
  };

  const handleDeleteWardLocation = (id) => () => {
    setForm((preData) => ({
      ...preData,
      specialtyWardloc: _.filter(preData.specialtyWardloc, (item) => item.id !== id),
    }));
  };

  const handleReset = (key) => () => {
    if (!defaultValue) return;

    if (key === 'redirOptAtWardAck') {
      setForm((preData) => ({
        ...preData,
        redirOptAtWardAck: _.some(defaultValue[key], (item) => item === 'NEXT')
          ? defaultValue[key]
          : [...defaultValue[key], 'NEXT'],
      }));
    } else {
      setForm((preData) => ({
        ...preData,
        [key]: defaultValue[key],
      }));
    }
  };

  // 必填输入框没输入的时候禁用submit按钮
  const submitDisable = useMemo(() => {
    // Ward Assignment By 必填
    // 当Ward Assignment By选择'BEDCO'或者勾选了Specialty Bed Co. of the case的时候，Bed Co. Unit必填
    // specialtyCode、subSpecialtyCode、isoRoom 至少有一个有值
    return (
      !form.wardAssignBy ||
      ((form.wardAssignBy === 'BEDCO' || _.some(form.redirOptAtWardAck, (item) => item === 'BEDCO')) &&
        !form.specialtyWardId) ||
      // specialtyCode 必填已经覆盖了之前这段逻辑
      // !(form.specialtyCode || form.subSpecialtyCode || form.isoRoom) ||
      !form.specialtyCode
    );
  }, [form]);

  return (
    <>
      <Dialog
        open={true}
        title={type === 'Add' ? 'Add Specialty' : 'Edit Specialty'}
        confirm={type === 'Add' ? 'Add' : 'Save'}
        handleClose={handleClose}
        handleConfirm={handleConfirm(form)}
        width="100%"
        confirmStyle={{ width: '12.5rem' }}
        dialogfootStyle={{ paddingTop: '1.875rem', boxShadow: '0px -1px 0px 0px #E4E7EB', marginTop: '2.5rem' }}
        disabled={submitDisable}
      >
        <Box display="flex" flexDirection="column" gridGap="1.88rem">
          <Box display="flex" justifyContent="space-between" gridGap="1.25rem">
            <Box display="flex" flexDirection="column" gridGap="1.88rem">
              <Box display="flex" gridGap="1.38rem">
                <Box display="flex" flexDirection="column" gridGap="0.63rem" flexBasis="50%">
                  <Text color="#2E4469" fontSize="1rem">
                    Specialty
                    <span className={classes.star}>*</span>
                  </Text>
                  <AutoCompleteInput
                    value={form.specialtyCode}
                    onChange={updateForm({ key: 'specialtyCode' })}
                    itemList={options.specialOptions}
                    placeholder="Select from below"
                    freeSolo
                  />
                </Box>
                <Box display="flex" flexDirection="column" gridGap="0.63rem" flexBasis="50%">
                  <Text color="#2E4469" fontSize="1rem">
                    Sub Specialty
                  </Text>
                  <AutoCompleteInput
                    value={form.subSpecialtyCode}
                    onChange={updateForm({ key: 'subSpecialtyCode' })}
                    itemList={options.subSpecialOptions}
                    placeholder="Select from below"
                    freeSolo
                  />
                </Box>
                <Box display="flex" flexDirection="column" gridGap="0.63rem" flexBasis="50%">
                  <Text color="#2E4469" fontSize="1rem">
                    Isolation Room
                  </Text>
                  <AutoCompleteInput
                    value={form.isoRoom}
                    onChange={updateForm({ key: 'isoRoom' })}
                    itemList={options.isoRoomOptions}
                    placeholder="Select from below"
                  />
                </Box>
              </Box>
              <Box display="flex" gridGap="1.38rem">
                <Box display="flex" flexDirection="column" gridGap="0.63rem" flexBasis="50%">
                  <Box display="flex" justifyContent="space-between">
                    <Text color="#2E4469" fontSize="1rem">
                      Ward Assignment By<span className={classes.star}>*</span>
                    </Text>
                    <ButtonBase className={classes.btn} onClick={handleReset('wardAssignBy')}>
                      <Reset2 /> Reset to default value
                    </ButtonBase>
                  </Box>
                  <AutoCompleteSelect
                    value={form.wardAssignBy}
                    onChange={updateForm({ key: 'wardAssignBy' })}
                    itemList={options.wardAssignmentList}
                    placeholder="Select from below"
                  />
                </Box>
                <Box display="flex" flexDirection="column" gridGap="0.63rem" flexBasis="50%">
                  <Box display="flex" justifyContent="space-between">
                    <Text color="#2E4469" fontSize="1rem">
                      Bed Co. Unit
                      {(form.wardAssignBy === 'BEDCO' ||
                        _.some(form.redirOptAtWardAck, (item) => item === 'BEDCO')) && (
                        <span className={classes.star}>*</span>
                      )}
                    </Text>
                    <ButtonBase className={classes.btn} onClick={() => setAddUnit(true)}>
                      <AddIcon className={classes.addIcon} /> Add Unit
                    </ButtonBase>
                  </Box>
                  <AutoCompleteSelect
                    value={form.specialtyWardId}
                    onChange={updateForm({ key: 'specialtyWardId' })}
                    itemList={options.wardItemOptions}
                    placeholder="Bed Co. Unit"
                  />
                </Box>
              </Box>
              <Box display="grid" gridGap="1.7rem 1rem" gridTemplateColumns="1fr 1fr 1fr">
                <Text color="#2E4469" fontSize="1rem">
                  Status
                </Text>
                <Text color="#2E4469" fontSize="1rem">
                  Redirection Option @Ward Ack.<span className={classes.star}>*</span>
                </Text>
                <Box display="flex" justifyContent="flex-end">
                  <ButtonBase className={classes.btn} onClick={handleReset('redirOptAtWardAck')}>
                    <Reset2 /> Reset to default value
                  </ButtonBase>
                </Box>
                <Box display="flex" flexDirection="column" gridGap="0.62rem" style={{ gridRowStart: 'span 3' }}>
                  <Box display="flex" gridGap="0.62rem">
                    <Checkbox check={form.isActive === 1} handleChange={updateForm({ key: 'isActive' })} />
                    <Text color="#2E4469" fontSize="1rem">
                      Active
                    </Text>
                  </Box>
                  <Box display="flex" gridGap="0.62rem">
                    <Checkbox check={form.isMatchedAge} handleChange={updateForm({ key: 'isMatchedAge' })} />
                    <Text color="#2E4469" fontSize="1rem">
                      {`In manual ward assignment filter, show matched patient\'s age ward only by default`}
                    </Text>
                  </Box>
                </Box>
                <Box display="flex" gridGap="0.62rem">
                  <Checkbox check={_.some(form.redirOptAtWardAck, (item) => item === 'NEXT')} />
                  <Text color="#2E4469" fontSize="1rem">
                    Next assigned ward(if applicable)
                  </Text>
                </Box>
                <Box display="flex" gridGap="0.62rem">
                  <Checkbox
                    check={_.some(form.redirOptAtWardAck, (item) => item === 'BEDCO')}
                    handleChange={updateForm({ key: 'redirOptAtWardAck', keyword: 'BEDCO' })}
                  />
                  <Text color="#2E4469" fontSize="1rem">
                    Specialty Bed Co. of the case
                  </Text>
                </Box>
                <Box display="flex" gridGap="0.62rem">
                  <Checkbox
                    check={_.some(form.redirOptAtWardAck, (item) => item === 'ADM')}
                    handleChange={updateForm({ key: 'redirOptAtWardAck', keyword: 'ADM' })}
                  />
                  <Text color="#2E4469" fontSize="1rem">
                    Admission Officer
                  </Text>
                </Box>
                <Box display="flex" gridGap="0.62rem">
                  <Checkbox
                    check={_.some(form.redirOptAtWardAck, (item) => item === 'ANY')}
                    handleChange={updateForm({ key: 'redirOptAtWardAck', keyword: 'ANY' })}
                  />
                  <Text color="#2E4469" fontSize="1rem">
                    Any wards
                  </Text>
                </Box>
                <Box display="flex" gridGap="0.62rem">
                  <Checkbox
                    check={_.some(form.redirOptAtWardAck, (item) => item === 'SPECIALTY_ONLY')}
                    handleChange={updateForm({ key: 'redirOptAtWardAck', keyword: 'SPECIALTY_ONLY' })}
                  />
                  <Text color="#2E4469" fontSize="1rem">
                    Wards of this specialty only
                  </Text>
                </Box>
              </Box>
            </Box>
            <Box display="flex" flexDirection="column" gridGap="0.62rem" width="51.375rem">
              <Box display="flex" alignItems="flex-end" justifyContent="space-between">
                <Box display="flex" flexDirection="column">
                  <Text color="#2E4469" fontSize="1rem">
                    Additional Remark Template
                  </Text>
                  <Text color="#2E4469" fontSize="1rem">
                    @ Emergency Admission Form
                  </Text>
                </Box>
                <ButtonBase className={classes.btn} onClick={handleReset('additionalRemark')}>
                  <Reset2 /> Reset to default value
                </ButtonBase>
              </Box>
              <Box width="100%">
                <RichText value={form.additionalRemark} onChange={updateForm({ key: 'additionalRemark' })} />
              </Box>
            </Box>
          </Box>
          <div className={classes.border} />
          <Box>
            <Text color="#2E4469" fontSize="1.5rem" fontFamily="NotoSans-Bold">
              Ward Location
            </Text>
            {form.specialtyWardloc.map((item) => (
              <Box key={item.id} display="flex" flexDirection="column" mt="1.87rem" gridGap="1.25rem">
                <Box display="flex" gridGap="1.25rem">
                  <TitleBox title="Gender" flex={1} style={{ textTransform: 'uppercase' }}>
                    <AutoCompleteSelect
                      value={item.gender}
                      onChange={updateForm({ key: 'specialtyWardloc', id: item.id, keyword: 'gender' })}
                      itemList={options.genderOptions}
                      placeholder="Select from below"
                    />
                  </TitleBox>
                  <TitleBox title="Hosp" flex={1} style={{ textTransform: 'uppercase' }}>
                    <AutoCompleteSelect
                      value={item.ipasHospCode}
                      onChange={updateForm({ key: 'specialtyWardloc', id: item.id, keyword: 'ipasHospCode' })}
                      itemList={options.hospCodeOptions}
                      placeholder="Select from below"
                    />
                  </TitleBox>
                  <TitleBox title="IPAS Ward Loc." flex={1} style={{ textTransform: 'uppercase' }}>
                    <AutoCompleteSelect
                      value={item.ipasWardLocation}
                      onChange={updateForm({ key: 'specialtyWardloc', id: item.id, keyword: 'ipasWardLocation' })}
                      itemList={wardLocationGetter(item.ipasHospCode)}
                      placeholder="Select from below"
                    />
                  </TitleBox>
                  <TitleBox title="Ward Place unit" flex={1} style={{ textTransform: 'uppercase' }}>
                    <AutoCompleteSelect
                      value={item.unitId}
                      onChange={updateForm({ key: 'specialtyWardloc', id: item.id, keyword: 'unitId' })}
                      itemList={wardGetter(item.ipasHospCode, item.ipasWardLocation)}
                      placeholder="Select from below"
                    />
                  </TitleBox>
                  <TitleBox title="Occupancy Threshold" flex={1} style={{ textTransform: 'uppercase' }}>
                    <StyleInput
                      value={item.occThreshold}
                      onChange={updateForm({ key: 'specialtyWardloc', id: item.id, keyword: 'occThreshold' })}
                      width="100%"
                      placeholder="Input"
                      endAdornment="%"
                      type="number"
                    />
                  </TitleBox>
                  <TitleBox title="Age" flex={1} style={{ display: 'flex' }}>
                    <Box display="flex" gridGap="0.3rem">
                      <AutoCompleteSelect
                        value={item.range}
                        onChange={updateForm({ key: 'specialtyWardloc', id: item.id, keyword: 'range' })}
                        itemList={ageRangeOptions}
                        placeholder="Select from below"
                        style={{ flex: 1 }}
                      />
                      <StyleInput
                        value={item.age}
                        onChange={updateForm({ key: 'specialtyWardloc', id: item.id, keyword: 'age' })}
                        placeholder="Input"
                        width="35%"
                        type="number"
                      />
                    </Box>
                  </TitleBox>
                  <TitleBox title="&nbsp;">
                    {form.specialtyWardloc.length > 1 && (
                      <Box p="0.63rem 0">
                        <ButtonBase className={classes.deleteBtn} onClick={handleDeleteWardLocation(item.id)}>
                          <DeleteIcon className={classes.deleteIcon} />
                        </ButtonBase>
                      </Box>
                    )}
                  </TitleBox>
                </Box>
              </Box>
            ))}
            <Box display="flex" mt="1.25rem">
              <ButtonBase className={classes.btn} onClick={handleAddWardLocation}>
                <AddIcon className={classes.addIcon} />
                Add More
              </ButtonBase>
            </Box>
          </Box>
        </Box>
      </Dialog>
      {addUnit && <AddWardPop closePop={() => setAddUnit(false)} open={addUnit} confirmClick={addPopConfirmClick} />}
    </>
  );
};

export default SpecialtiesPopup;
